export class AutoTimerObserver {
  constructor() {
    this.observer = new MutationObserver(this._handleMutations.bind(this));
    this.initExistingTimers();
    this.observeDocument();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  initExistingTimers() {
    document.querySelectorAll('.auto-secudomer').forEach((elem) => {
      this.initializeTimer(elem);
    });
  }

  _handleMutations(mutations) {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches('.auto-secudomer')) {
              this.initializeTimer(node);
            }
            node.querySelectorAll('.auto-secudomer').forEach((child) => {
              this.initializeTimer(child);
            });
          }
        });
      }
    });
  }

  initializeTimer(element) {
    // Предотвращаем повторную инициализацию
    if (element.dataset.timerInitialized) return;
    element.dataset.timerInitialized = 'true';

    // Парсим начальное значение секунд из содержимого элемента
    let seconds = parseInt(element.textContent, 10);
    if (isNaN(seconds)) seconds = 0;

    const formatTime = (secs) => {
      const hours = Math.floor(secs / 3600);
      const minutes = Math.floor((secs % 3600) / 60);
      const secsRemaining = secs % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${secsRemaining.toString().padStart(2, '0')}`;
    };

    // Обновляем содержимое элемента в нужном формате
    element.textContent = formatTime(seconds);

    // Каждую секунду увеличиваем значение и обновляем таймер
    setInterval(() => {
      seconds++;
      element.textContent = formatTime(seconds);
    }, 1000);
  }
}
